/**
 * @param {String} name URL parameter name you want the value for
 * @returns {(String | undefined)} value for given URL parameter
 */
function getUrlParameter(name) {
  try {
    const regex = new RegExp('[\\?&]' + name.toLowerCase() + '=([^&#]*)', 'i')
    const results = regex.exec(location.search)
    return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '))
  } catch (ignore) {
    return undefined
  }
}

export default getUrlParameter
